import React, { useCallback, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getAssetColor, GetQueryParam, isLogged, validateStringValue } from '../../utils/common';
import { useNavigate } from 'react-router-dom';
import { trackSupportTicket } from '../../router/roleWisePageRoute';
import { RibbonContainer } from '../../components/TicketExecution/RibbonContainer';
import { isMilestoneStatusInRange, MilestoneSubStatus, TicketAgentRole } from '../Ticket/TicketController';
import { generateSignoffReport, generateTicketReport } from '../../actions/service_request';
import { copyToClipboard } from '../../actions/utils';
import OverflowTip from '../../common/OverflowTip';
import UserPopup from '../../common/Popups/User';
import IconToolTip from '../../common/IconToolTip';
import ButtonScogoOrange from '../../common/Buttons/ButtonScogoOrange';
import { LineClampComponent } from '../Ticket/TicketTableComponent';
import AssetPopup from '../../common/Popups/AssetPop';
import moment from 'moment';
import { SkeltonCardTwo } from '../../common/SkeltonCardTwo';
import { getAuthRoute } from '../../router/Routes';
import ButtonScogoPrimary from '../../common/Buttons/ButtonScogoPrimary';

export default function Details({ ticketId, mainDivClass = '' }) {
    const supportTrackServiceRequest = useSelector((state) => state.serviceRequest.supportTrackServiceRequest);
    const isSupportTrackServiceRequestLoading = useSelector((state) => state.loading.isSupportTrackServiceRequestLoading);
    const newLoggedUserData = useSelector((state) => state.auth.newLoggedUserData);
    const navigate = useNavigate();
    const shared_by = GetQueryParam('shared_by');

    const memoizedTicketDetails = useMemo(() => {
        let details = {};
        if (supportTrackServiceRequest) details = supportTrackServiceRequest;
        return details;
    }, [supportTrackServiceRequest]);

    const onNextClick = useCallback(async () => {
        let path = `${trackSupportTicket.path}?ticketId=${ticketId}&redirectTo=chat`;
        if (shared_by) path = `${path}&shared_by=${shared_by}`;
        if (newLoggedUserData && isLogged()) {
            navigate(path);
        } else {
            const url = await getAuthRoute({ support_view: true, ticket_id: ticketId });
            window.open(url, '_self');
        }
    }, [ticketId, shared_by, newLoggedUserData, navigate]);


    if (isSupportTrackServiceRequestLoading) {
        return <div className='flex justify-center items-center h-full'>
            <SkeltonCardTwo arr={[1, 2, 3, 4, 5, 6, 7, 8]} />
        </div>
    }

    return <div className="w-full flex flex-col items-center bg-scogolightblue  overflow-hidden h-full">
        <div className='w-full overflow-y-auto overflow-x-hidden py-1 px-4 md:px-8' style={{ maxHeight: '90%' }}>
            <div className={`grid grid-cols-1 gap-4 md:grid md:grid-cols-2 md:grid-gap-4 py-4 h-full`} >
                <RenderContactInfo memoizedTicketDetails={memoizedTicketDetails} />
                {memoizedTicketDetails && <RenderBasicInfo serviceRequest={memoizedTicketDetails} />}
            </div>
        </div>
        <div style={{ height: '10%' }} className='flex gap-2 justify-end py-4 px-4'>
            <ButtonScogoPrimary buttonPadding='px-10 py-2 text-font15 md:text-font12' textOrComponent={'Next'} onClick={onNextClick} />
        </div>
    </div>
}

export const RenderContactInfo = ({ memoizedTicketDetails }) => {

    const memoizedAgents = useMemo(() => {
        let list = [];
        if (memoizedTicketDetails.agents) {
            let filteredAgents = memoizedTicketDetails.agents.filter(({ role }) => [TicketAgentRole.CLUSTER, TicketAgentRole.PSP, TicketAgentRole.SUPERVISOR, TicketAgentRole.PM, TicketAgentRole.SP, TicketAgentRole.FE].includes(role));
            list.push(...Array.from(new Map(filteredAgents.map(item => [`${item.role}_${item.agent.id}`, item])).values()));
        }
        return list;
    }, [memoizedTicketDetails]);

    const dispatch = useDispatch();
    return <RibbonContainer headerLabel={'Contact'}>
        <div className=' col-span-2 gap-3 grid grid-cols-2 justify-around mt-[0.5rem]  '>
            {memoizedAgents?.map((user, i) => {
                let lastIndex = i === memoizedAgents.length - 1 ? i : 1;
                let isToShowRanderComponent = memoizedAgents.length % 2 === 0
                let userLength = memoizedAgents.length
                return <div
                    key={i}
                    className={`bg-scogolightblue  mt-3 border text-center cursor-pointer rounded-md w-full shadow-md  ${lastIndex % 2 === 0 ? 'col-span-2' : ''
                        }`}
                >
                    <div className='relative bg-scogoorange '>
                        <p className='bg-scogoorange text-white text-font10 px-2  shadow-md rounded-3px w-full truncate'>{user.role}</p>

                        {isToShowRanderComponent && <p className='ml-auto absolute right-2 text-left text-white' style={{ top: '0rem' }}>
                            {user.renderComponent ? user.renderComponent : <></>}
                        </p>}
                    </div>
                    <div className='mt-1 px-2 ' >
                        {(user?.agent?.id && isLogged()) ? <UserPopup
                            userId={user?.agent?.id}
                            anchorOrigin={{
                                vertical: 'center',
                                horizontal: 'left',
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                        >
                            <span className='text-font11  text-scogoprimary pt-6 font-semibol max-w-5/7 m-auto'>
                                <OverflowTip someLongText={user.agent.display_name} />
                            </span>
                        </UserPopup> : <p className='text-font11 text-scogoprimary font-semibol max-w-5/7 m-auto'>
                            <OverflowTip someLongText={user.agent.display_name} />
                        </p>}
                        <div className='flex justify-center relative'>
                            <p className='text-font10 font-normal text-scogogray' onClick={(e) => {
                                dispatch(copyToClipboard({ data: user.agent.phone_number }));
                            }}>{user.agent.phone_number}</p>
                            {userLength % 2 === 1 && <p className='ml-auto absolute right-2 text-left text-font11 hover:text-scogoorange text-scogoprimary'>
                                {user.renderComponent ? user.renderComponent : <></>}
                            </p>}
                        </div>

                    </div>
                </div>
            })}
        </div>
    </RibbonContainer>
}

export const RenderBasicInfo = ({ serviceRequest }) => {
    const dispatch = useDispatch();
    const formButtonLoading = useSelector((state) => state.loading.formButtonLoading);
    const disabledClass = 'text-black flex items-center justify-center rounded-6px shadow-primaryBtnShadow px-4 text-xl gap-1 font-medium relative cursor-not-allowed border-scogoddd bg-scogoddd m-auto py-1';


    const sow = serviceRequest.attributes?.find((item) => item.key === 'sow');
    const report = serviceRequest.milestones && isMilestoneStatusInRange(serviceRequest.milestones, MilestoneSubStatus.SIGN_OFF_ACCEPTED);
    const signoff_sample = !report && serviceRequest.attributes?.find((item) => item.key === 'signoff_sample');

    const execution_dates = useMemo(() => {
        let dates = [];
        serviceRequest.milestones?.map(({ execution_dates }) => {
            dates.push(...execution_dates);
        });
        return dates;
    }, [serviceRequest.milestones]);

    const onSignOfflick = () => {
        if (serviceRequest.metadata && serviceRequest.metadata.sign_off_template_id) {
            dispatch(generateSignoffReport({ ticketId: serviceRequest.id, formName: 'generateSignoffReport' }));
        } else {
            window.open(signoff_sample.value.link, '_blank')
        }
    }

    const scogoReport = () => {
        dispatch(generateTicketReport({ ticketId: serviceRequest.id, formName: 'generateTicketReport' }));
    }

    return <div className=' relative '>
        <RibbonContainer headerLabel={'Basic Info'} isCollapsible>

            <div className='absolute right-2 flex gap-x-1 top-4 '>
                {sow && <IconToolTip title='SOW'>
                    <span>
                        <ButtonScogoOrange disabledClass={disabledClass} loading={false} textOrComponent={'SOW'} onClick={() => window.open(sow.value.link, '_blank')} />
                    </span>
                </IconToolTip>
                }
                {signoff_sample && <IconToolTip title='Sign Off Sample'>
                    <span>
                        <ButtonScogoOrange disabledClass={disabledClass} loading={formButtonLoading['generateSignoffReport']} textOrComponent={'Sign Off Sample'} onClick={onSignOfflick} />
                    </span>
                </IconToolTip>}
                {report && <IconToolTip title='Scogo Report'>
                    <span>
                        <ButtonScogoOrange disabledClass={disabledClass} loading={formButtonLoading['generateTicketReport']} textOrComponent={'Scogo Report'} onClick={() => scogoReport(serviceRequest.id)} />
                    </span>
                </IconToolTip>}
            </div>

            <div className='w-full gap-x-2 grid grid-cols-2 gap-y-2 justify-around  col-span-2 mt-14'>
                {serviceRequest?.project?.name && (
                    <OverflowTip someLongText={` ${serviceRequest.project.name}`} textClass="text-font10 font-normal text-scogograytext-scogoprimary" />

                )}
                <div className='text-center '>
                    {(serviceRequest.use_case_name || serviceRequest.service_type) && (
                        <OverflowTip textClass={"text-font11 text-scogoprimary text-center"} someLongText={` ${serviceRequest.use_case_name ? serviceRequest.use_case_name : ""} ${serviceRequest.service_type && serviceRequest.use_case_name ? '/' : ''} ${serviceRequest.service_type && ` ${serviceRequest.service_type} `}`} />

                    )}
                </div>
                <div className=' flex w-full   col-span-2'>
                    <p className='flex w-11/12 '>
                        <p className='w-[17%] text-font11  text-scogogray' >Address : </p>
                        <p className='w-[80%] text-font11 '>
                            <OverflowTip
                                someLongText={`${validateStringValue(serviceRequest?.location?.address)}`}
                            />
                        </p>
                    </p>

                    <p className='ml-auto px-2'>
                        <IconToolTip placement={'bottom'} title={`Copy Site Address`}>
                            <span
                                className='cursor-pointer material-icons text-scogobgsky text-lg '
                                onClick={() =>
                                    dispatch(
                                        copyToClipboard({
                                            data: `${validateStringValue(serviceRequest?.location?.address)}`,
                                        })
                                    )
                                }
                            >
                                content_copy
                            </span>
                        </IconToolTip>
                    </p>
                </div>

                {serviceRequest?.location?.external_id > 0 && (
                    <div className='col-span-2'>
                        <p className='text-font11 mb-1 text-scogogray'>Site id: {serviceRequest?.location?.external_id}</p>
                        <div className='flex gap-x-2'>
                            <div className='max-w-8/8'>
                                <OverflowTip someLongText={serviceRequest?.location?.external_id} />
                            </div>
                            <div>
                                <IconToolTip placement={'bottom'} title={`Copy Site Address`}>
                                    <span
                                        className='cursor-pointer material-icons text-scogobgsky text-lg'
                                        onClick={() =>
                                            dispatch(
                                                copyToClipboard({
                                                    data: `${serviceRequest?.location?.external_id}`,
                                                })
                                            )
                                        }
                                    >
                                        content_copy
                                    </span>
                                </IconToolTip>
                            </div>
                        </div>
                    </div>
                )}
                <div className='col-span-2'>
                    {(serviceRequest?.project?.description || serviceRequest?.description) && (
                        <>
                            <p className='text-font11 mb-1 text-scogogray'>Description</p>
                            <LineClampComponent value={serviceRequest?.description ? serviceRequest?.description : serviceRequest?.project?.description} />
                        </>
                    )}
                </div>

                <div className='col-span-2  flex   gap-x-7'>
                    <div>
                        <p className='text-font11 mb-1 text-scogogray'>Created At</p>
                        <span className='bg-scogoLogoGreen  text-white max-w-max text-font10 px-2 py-1 rounded-3px'>{moment(serviceRequest.created_at).format('DD MMM YY')}</span>
                    </div>

                    {execution_dates && execution_dates.length > 0 ? (
                        execution_dates.map(({ date }) => {
                            return (
                                <div>
                                    <p className='text-font11 mb-1 text-scogogray'>Execution</p>
                                    <div className='bg-scogoLogoGreen text-white min-w-[5rem] text-center max-w-max m-auto text-font10 px-2 py-1 rounded-3px'>
                                        {moment(date).format('DD MMM YY ')}
                                        <br />
                                        <span className="text-font09" >
                                            {moment(date).format('hh:mm A')}
                                        </span>

                                    </div>
                                </div>
                            )
                        })
                    ) : (
                        <></>
                    )}
                </div>

                <div className='col-span-2'>
                    <h3 className={'text-scogo99 text-font11 font-medium truncate'}>Remark </h3>
                    <div className='flex-wrap flex items-center line clamp-2 gap-x-2'>
                        {serviceRequest.remarks?.length > 0 ? (
                            <>
                                <div className='max-w-8/8 truncate'>
                                    {Array.isArray(serviceRequest.remarks) &&
                                        serviceRequest.remarks?.slice(0, 1)?.map((remark) => {
                                            let someLongText = (remark?.remark?.length > 0 ? remark?.remark : '') + (remark?.event?.length > 0 ? remark?.event : '');
                                            return <OverflowTip someLongText={someLongText} />;
                                        })}
                                </div>
                                {serviceRequest.remarks?.length > 1 && (
                                    <IconToolTip title='View all'>
                                        <span
                                            className='text-font12 round font-normal text-scogoorange cursor-pointer hover:text-scogobgsky'
                                        >
                                            +{serviceRequest.remarks?.length - 1}
                                        </span>
                                    </IconToolTip>
                                )}
                            </>
                        ) : (
                            <>No Remark</>
                        )}
                    </div>
                </div>

                <div className='col-span-2'>
                    <h3 className={'text-scogo99 text-font11 font-medium truncate mb-1'}>BOQ </h3>

                    <div className='flex-wrap flex items-center  gap-x-1 '>
                        {serviceRequest.assets?.slice(0, 4)?.map(({ asset }) => {
                            const status = `${asset?.status?.length > 0 ? ` ${asset?.status}` : ''}`;
                            const workingStatus = `${asset?.working_condition?.length > 0 ? `, ${asset?.working_condition}` : ''}`;
                            return (
                                <IconToolTip title={`${status} ${workingStatus}`} >
                                    <span className={`bg-${getAssetColor(asset)} cursor-pointer text-white max-w-12   text-font10 px-2 flex items-center rounded-3px mb-1`}>
                                        <span className='max-w-4/5 truncate'  >
                                            {(asset?.serial_number?.length > 0 ? asset?.serial_number : asset?.title)}
                                        </span>
                                        <span>
                                            {(asset?.count > 1 ? `: ${asset?.count}` : '')}
                                        </span>
                                        <span className="material-icons text-font12 ml-1 hover:text-scogobgsky" onClick={(event) => {
                                            event.stopPropagation();
                                            const text = asset?.serial_number?.length > 0 ? asset?.serial_number : asset?.title

                                            dispatch(copyToClipboard({ data: text }))
                                        }}>
                                            content_copy
                                        </span>
                                    </span>
                                </IconToolTip>
                            );
                        })}

                        {serviceRequest.assets?.length > 4 && (
                            <>

                                <AssetPopup assetList={serviceRequest.assets?.slice(4)} anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'right',
                                }}
                                    transformOrigin={{
                                        vertical: 'top',
                                        horizontal: 'left',
                                    }} >
                                    <span className='text-font12 round font-normal text-scogoorange relative cursor-pointer hover:text-scogobgsky countOfBOQ'>
                                        +{serviceRequest.assets?.length - 4}
                                    </span>
                                </AssetPopup>

                            </>
                        )}
                    </div>
                </div>
            </div>
        </RibbonContainer>
    </div>
};
